module.exports = __webpack_public_path__ + "img/jordflomskredaktsomhet.abcf0b08.jpg";